var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyZones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.439 8.507c4.013 1.306 6.533 4.933 6.653 5.12l.254.373-.254.387c-.146.226-3.84 5.6-9.506 5.6-.32 0-.627-.027-.934-.067v6.053c0 .267-.16.507-.4.614a.597.597 0 01-.266.053.683.683 0 01-.454-.173l-6.826-6.2-7.08 7.093-.947-.947L26.346.693l.946.947-6.853 6.867zm-5.12 5.133l-5.667 5.68 5.667 5.147V13.64zm1.333 4.933c.307.04.614.067.934.067 4.133 0 7.213-3.48 8.133-4.627-.773-.986-3.12-3.64-6.347-4.413l-2.28 2.293c.014 0 .027-.003.04-.006.014-.004.027-.007.04-.007 1.16 0 2.107.947 2.107 2.107 0 1.16-.947 2.106-2.107 2.106-.186 0-.36-.04-.52-.08v2.56z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.266 19.974H1.319a.669.669 0 01-.667-.667V8.64a.66.66 0 01.667-.666h7.067l7.146-6.494c.2-.186.48-.226.72-.12.24.107.4.347.4.614V8.08c.087-.006.17-.01.254-.013.083-.003.166-.007.253-.013l-1.84 1.84V3.48L9.106 9.134a.74.74 0 01-.454.173H1.986v9.333h4.613l-1.333 1.334z",
    fill: "#1998D5"
  })));
}
export default SvgPrivacyZones;